import './index.sass';

export default () => {
  const $root = $('.sidebar-settings');
  const $btn = $('.sidebar-settings__button');
  const $sidebarList = $('.sidebar-settings__list');

  const onAnchorScroll = () => {
    const $anchors = $('.js-anchor');
    if ($anchors.closest('.sidebar-settings__item--active').length) {
      $anchors.on('click', function(e) {
        e.preventDefault();
        const width = $(window).outerWidth() < 1080;
        let minusTop = width ? 65 : 0;
        const linkId = '#' + $(e.currentTarget).attr('href').split('#')[1];
        let top = $(linkId).offset().top;
        $('body,html').animate({scrollTop: top - minusTop }, 600);
        if (width) {
          $btn.removeClass('sidebar-settings__button--show');
          $sidebarList.slideUp("fast");
        }
      })
    }
  }
  onAnchorScroll();

  const showDropDown = () => {
    $btn.on('click', function() {
      $(this).toggleClass('sidebar-settings__button--show');
      $sidebarList.slideToggle("fast");
      $(document).on('click', closeDropDown);
    })
  }

  const closeDropDown = (e) => {
    const target = e.target;
    const itsMenu = target === $root || $root[0].contains(target);
    if (!itsMenu) {
      $btn.removeClass('sidebar-settings__button--show');
      $sidebarList.slideUp("fast");
      $(document).off('click', closeDropDown);
    }
  };

  showDropDown();
}
